import { ref, getCurrentInstance, nextTick, computed } from 'vue';
import { useStore } from 'vuex';
// Importujemy wspólne komponenty i moduły z main.js
import { sharedComponents, sharedElementPlusComponents } from '../utils/vue.js';
import { useCommonLogic } from '../utils/commonVue.js';
export default {
    components: {
        ...sharedComponents,
        ...sharedElementPlusComponents
    },
    setup () {
        const instance = getCurrentInstance();
        const commonLogic = useCommonLogic();
        const store = useStore();
        const searchFilter = ref([]);
        const searchSort = ref('desc');
        // Pobierz listę lekarzy ze store
        const doctors = computed(()=>store.state.doctors);
        const treatmentPath = ref([]);
        const sex = ref([]);
        const treatmentStage = ref([]);
        const servicesCategories = ref([]);
        const servicesTyp = ref([]);
        const categories = ref([]);
        const tags = ref([]);
        const post_type = ref('forum');
        // Filtruj lekarzy na podstawie searchFilter
        const filteredDoctors = computed(()=>{
            if (searchFilter.value.length === 0) {
                return []; // Jeśli brak filtrów, zwróć całą listę
            }
            return doctors.value.filter((doctor)=>searchFilter.value.includes(doctor.ID));
        });
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.size) {
            const filter = urlParams.has('filter') ? urlParams.get('filter') : null;
            const search1 = urlParams.has('search') ? urlParams.get('search') : null;
            const sort = urlParams.has('sort') ? urlParams.get('sort') : null;
            const treatment_path = urlParams.has('treatment_path') ? urlParams.get('treatment_path') : null;
            const sexParams = urlParams.has('sex') ? urlParams.get('sex') : null;
            const treatment_stage = urlParams.has('treatment_stage') ? urlParams.get('treatment_stage') : null;
            const services_categories = urlParams.has('services_categories') ? urlParams.get('services_categories') : null;
            const services_typ = urlParams.has('services_typ') ? urlParams.get('services_typ') : null;
            const categoriesParam = urlParams.has('categories') ? urlParams.get('categories') : null;
            const tagsParam = urlParams.has('tags') ? urlParams.get('tags') : null;
            const postType = urlParams.has('type') ? urlParams.get('type') : null;
            if (filter) {
                searchFilter.value = filter.split(',').map(Number);
            }
            if (sort) {
                searchSort.value = sort;
            }
            if (treatment_path) {
                treatmentPath.value = treatment_path.split(',').map(Number);
            }
            if (sexParams) {
                sex.value = sexParams.split(',').map(Number);
            }
            if (treatment_stage) {
                treatmentStage.value = treatment_stage.split(',').map(Number);
            }
            if (services_categories) {
                servicesCategories.value = services_categories.split(',').map(Number);
            }
            if (services_typ) {
                servicesTyp.value = services_typ.split(',').map(Number);
            }
            if (categoriesParam) {
                categories.value = categoriesParam.split(',').map(Number);
            }
            if (tagsParam) {
                tags.value = tagsParam.split(',').map(Number);
            }
            if (postType) {
                post_type.value = postType;
            }
            if (!filter && !search1 && !sort && !treatment_path && !sex && !treatment_stage && !services_categories && !services_typ) {
                const newUrl = window.location.pathname;
                window.history.replaceState(null, '', newUrl);
            } else {
                nextTick(()=>{
                    instance.proxy.ScrollTo('list');
                });
            }
        }
        const handleClose = async (id)=>{
            searchFilter.value = searchFilter.value.filter((item)=>item !== id);
            await nextTick();
            document.querySelector('.archive-filter-form').requestSubmit();
        };
        const submit = ()=>{
            document.querySelector('.search-post').requestSubmit();
        };
        const removeParams = ()=>{
            searchFilter.value = [];
            search.value = [];
            treatmentPath.value = [];
            sex.value = [];
            treatmentStage.value = [];
            servicesCategories.value = [];
            servicesTyp.value = [];
            categories.value = [];
            tags.value = [];
            post_type.value = 'all';
            const newUrl = window.location.pathname.replace(/\/page\/\d+/, '');
            window.history.replaceState(null, '', newUrl);
            window.location.reload();
        };
        return {
            ...commonLogic,
            searchFilter,
            searchSort,
            filteredDoctors,
            treatmentPath,
            sex,
            treatmentStage,
            servicesCategories,
            servicesTyp,
            categories,
            tags,
            post_type,
            handleClose,
            submit,
            removeParams
        };
    }
};
